var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.DataTypeNetcdf = {
    get_data_variable: function (data_var, data_unit) {
        if (!data_var) {
            return false;
        }
        var out = false;
        if (OCS.Utilities.is_string(data_var)) {
            data_var = {'parm': data_var};
            if (data_unit) {
                data_var.units = data_unit;
            }
        }
        var data = this.data();
        var vars = this.get_variables();
        if (vars.contains(data_var.parm)) {
            if (data_unit && data[data_var.parm].units !== data_unit) {
                // So we have the data, but its in the wrong units
                if (!vars.contains(data_var.parm + "|" + data_unit)) {
                    return false;
                } else {
                    data_var.parm += "|" + data_unit;
                }
            }
            out = Object.subset(data, ['lat', 'lon', 'stid', data_var.parm]);
        }
        return out;
    },
    /**
     * Returns the array of variables ['var1', 'var2']
     * @returns {Array}
     */
    get_variables: function () {
        return OCS.Utilities.array_subtract(Object.keys(this.data()), ['lat', 'lon', 'stid']);
    },
    /**
     * Returns the units of the variable
     * @param {type} variable
     * @returns String
     */
    get_variable_units: function (variable) {
        var data = this.get_data_variable(variable);
        return data[variable].units;
    },
    add_data_variable: function (data_in) {
        if (!data_in) {
            return false;
        }
        Object.append(this.data(), data_in);
        return true;
    },
    is_gridded: function () {
        return false;
    },
    is_valid: function (data_var, data_unit) {
        if (!data_var) {
            data_var = this.get_variables()[0];
            data_unit = this.get_variable_units(data_var);
        }
        var data = this.get_data_variable(data_var, data_unit);
        if (OCS.Utilities.array_equal_check(data[data_var].data) && OCS.Utilities.array_null_check(data[data_var].data)) {
            // Data is all null, not valid
            return false;
        }
        return true;
    }
};